import {TypeOf, array, number, type} from 'io-ts';
import {nullable} from '~/library/io-ts-tools';
import {TransactionSchema} from './TransactionSchema';

export const TransactionListSchema = type({
    orders: array(TransactionSchema),
    total: number,
    limit: number,
    last: nullable(number),
});

export type TransactionListSchema = TypeOf<typeof TransactionListSchema>;
